import { useCallback, useContext } from 'react';
import SavedFiltersContext from '../../../../DatasetFilters/SavedFilters/context/SavedFiltersContext';
import usesFieldInPlates from './usesFieldInPlates';

/**
 * Returns a list of saved dataset filters that directly reference the field in any plate
 */
const useGetFieldSavedFilterUsage = () => {
  const { savedFilters } = useContext(SavedFiltersContext);

  const getFieldSavedFilterUsage = useCallback(
    (field: string, dataset: string) => {
      return savedFilters.filter((sf) =>
        usesFieldInPlates(sf.plates, field, dataset),
      );
    },
    [savedFilters],
  );

  return getFieldSavedFilterUsage;
};

export default useGetFieldSavedFilterUsage;
